<template>
  <div>
    <van-nav-bar left-arrow fixed title="拍品资产详情" @click-left="goableBack()" :z-index="10"></van-nav-bar>

    <div class="main">
      <div class="main-box fy">
        <!-- header -->
        <div class="header">
          <div class="title">
            <router-link :to="{
                // path: '/claimDetail',
                path: '/detail',
                query: { productId: invest.productId }
              }">{{ invest.productName }}</router-link>
            <van-icon color="#c6c6c6" name="arrow" />
          </div>
          <div class="center">
            <div class="t">{{ numFormat(invest.auctionPayAmount) }}</div>
            <div class="d">委托竞买出价(元)</div>
          </div>
          <template v-if="invest.auctionProductList == 0">
            <div class="down">
              <div class="down-left">
                <span>预期年化折扣率：</span>
                <span class="left-value">{{ invest.rate || 0.0 }}%</span>
              </div>
              <div class="down-right">
                <span>期限：</span>
                <span class="right-value">{{ invest.investDuration || 0 }}天</span>
              </div>
            </div>
          </template>
          <!-- <div class="down">
            <div class="down-left">
              <span>委托竞买登记日</span>
              <br />
              <span class="left-value">{{
                dateFormat(invest.createTime, "YYYY-MM-DD")
              }}</span>
            </div>
            <div class="down-right">
              <span>剩余拍品公告期限</span>
              <br />
              <span class="right-value">{{ invest.auctionDuration }}天</span>
            </div>
          </div> -->
          <van-tag size="large" mark :color="tags[status].bg" :text-color="tags[status].color">{{ tags[status].text }}</van-tag>
        </div>
        <div class="income">
          <div class="first">
            <span class="left">折扣金额(元)</span>
            <span class="right money">{{
              numFormat(invest.returnAmount)
            }}</span>
          </div>
          <div class="first">
            <span class="left" v-if="status == 1">预计成交日</span>
            <span class="left" v-else>拍品成交日</span>
            <span class="right">{{
              dateFormat(invest.beginTime, "YYYY-MM-DD")
            }}</span>
          </div>
          <div class="first">
            <span class="left">拍品到期日</span>
            <span class="right">{{
              dateFormat(invest.endTime, "YYYY-MM-DD")
            }}</span>
          </div>
          <template v-if="invest.auctionProductList == 0">
            <div class="first">
              <span class="left">操作</span>
              <div class="look-protocol">
                <router-link class="look-sure" v-if="invest.isShowConfirmFile == 1" :to="{
                    name: 'agreement-trade',
                    query: {
                      pushType: 3,
                      productId: invest.productId,
                      title: '资产确认书'
                    }
                  }">查看确认书</router-link>
                <router-link :to="{
                    name: 'agreement-trade',
                    query: {
                      pushType: 1,
                      id: invest.id,
                      title: '委托竞买系列协议'
                    }
                  }">查看协议</router-link>
              </div>
            </div>
          </template>
        </div>

        <div class="plan fy">
          <van-collapse v-model="activeNames">
            <van-collapse-item name="1" v-if="invest.returnPlans && invest.returnPlans.length > 0">
              <template #title>
                <div class="first">回款计划</div>
              </template>
              <table class="table">
                <tr>
                  <th>期数</th>
                  <th>预期回款</th>
                  <th>拍品结算日</th>
                  <th>状态</th>
                </tr>
                <tr v-for="(n, i) of invest.returnPlans" :key="i">
                  <td>{{ n.step }}</td>
                  <td>{{ numFormat(n.amount) }}</td>
                  <td>{{ dateFormat(n.payTime, "YYYY-MM-DD") }}</td>
                  <td>{{ statusText[n.status] }}</td>
                </tr>
              </table>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
      <!--  -->
      <div class="auctionDetail" v-if="
          invest.auctionProductList && invest.auctionProductList.length > 0
        ">
        <div class="box">
          <div class="top-box">
            <div class="title">委托竞买记录</div>
            <div class="look-protocol">
              <router-link class="look-sure" v-if="invest.isShowConfirmFile == 1" :to="{
                  name: 'agreement-trade',
                  query: {
                    pushType: 3,
                    productId: invest.productId,
                    title: '资产确认书'
                  }
                }">查看确认书</router-link>
              <router-link :to="{
                  name: 'agreement-trade',
                  query: {
                    pushType: 1,
                    id: invest.id,
                    title: '委托竞买系列协议'
                  }
                }">查看协议</router-link>
            </div>
          </div>
          <table>
            <thead>
              <tr>
                <th>债权编号</th>
                <th>委托竞买出价(元)</th>
                <th>预期年化折扣率</th>
                <th>折扣金额(元)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(n, i) of invest.auctionProductList" :key="`buy-${i}`">
                <td>{{ getAuctionProductId(n) }}</td>
                <td>{{ numFormat(n.auctionPayAmount) }}</td>
                <td>{{ n.rate }}%</td>
                <td>{{ n.income / 100 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- 撤销 -->
    <div class="aginstshop">
      <van-button v-if="invest.status == 1" class="buy" plain size="large" @click="showPopup">撤销</van-button>
    </div>
    <!-- popup -->
    <van-popup duration="0.5" round v-model="show">
      <div class="popup-content">
        <div class="title">
          募集期内，如果您后悔认购，可撤销认购。撤销成功后，已认购资金将退回到您的余额账户。确定撤销吗？
        </div>
        <div class="select">
          <van-button class="sp1" square @click="show = false">取消</van-button>
          <van-button class="sp2" square :loading="loading" @click="onRevoke">确认</van-button>
        </div>
      </div>
    </van-popup>
    <!-- 是否进行风险测评 -->
    <van-popup class="assess-dialog" v-model="assessShow">
      <h2 class="mt-0 fs-xxl ta-c">您还没有完成风险测评</h2>
      <div class="mb-20">
        根据相关法规，买入前先进行测评，以便了解自身的风险承受能力，做出理性投资决策
      </div>
      <div class="ta-c">
        <van-button class="btn-assess" plain @click="goAssess">立即测评</van-button>
      </div>
    </van-popup>
    <!-- 风险测评是否强制显示重新测评 -->
    <van-popup class="assess-dialog" v-model="resetAssessShow">
      <h2 class="mt-0 fs-xxl ta-c">温馨提示</h2>
      <div class="mb-20">
        您好！您之前的风险测评已到期，需要重新进行风险测评，请前往测评！
      </div>
      <div class="ta-c">
        <van-button class="btn-assess" plain @click="goAssess">立即测评</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Icon, Cell, Tag, Collapse, CollapseItem, Button, Popup } from "vant"
import { mapGetters } from "vuex"
import { cancelAuctionInvest, getAuctionInvestDetail } from "../../api/auction"
export default {
  components: {
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Button.name]: Button,
    [Popup.name]: Popup
  },
  props: {
    productId: {
      required: true,
      type: String
    },
    status: {
      required: true,
      type: [Number, String]
    }
  },
  computed: {
    ...mapGetters(["userInfo", "token", "deviceToken", "channel"]),
    investRate() {
      if (this.invest.max == null && this.invest.min == null) {
        return this.invest.rate + "%"
      } else {
        if (this.invest.max === this.invest.min) {
          return this.invest.max + "%"
        } else {
          return this.invest.min + "%" + "~" + this.invest.max + "%"
        }
      }
    }
  },
  data: () => ({
    show: false,
    loading: false,
    assessShow: false,
    resetAssessShow: false,
    activeNames: ["1"],
    invest: {},
    tags: {
      1: { bg: "#5ac909", text: "申请中", color: "#fff" },
      2: { bg: "#fcd32b", text: "持有中", color: "#61531e" },
      3: { bg: "#f62f1a", text: "已结清", color: "#fff" }
    },
    statusText: {
      0: "待收款",
      1: "已收款",
      3: "待收款",
      4: "待收款"
    }
  }),
  beforeMount() {
    //检测测评
    //forceAssess 是否强制评测
    //assessNum 已评测次数
    console.log("beforeMount")
    this.resetAssessShow =
      this.userInfo.userLevel > 0 ? this.userInfo.forceAssess : false
    if (this.userInfo.userLevel < 1) {
      this.assessShow = this.resetAssessShow == true ? false : true
    }
  },
  beforeRouteEnter(to, from, next) {
    let p1 = getAuctionInvestDetail({
      investId: to.params.productId,
      status: to.params.status
    })
    Promise.all([p1])
      .then((datas) => {
        next((vm) => vm.setData(datas))
      })
      .catch((e) => {
        console.info(e)
      })
  },
  beforeRouteUpdate(to, from, next) {
    let p1 = getAuctionInvestDetail(to.params.productId, to.params.status)
    Promise.all([p1])
      .then((datas) => {
        this.setData(datas)
        next()
      })
      .catch((e) => {
        console.info(e)
      })
  },
  methods: {
    setData(datas) {
      this.invest = datas[0]
      // 3006 用户放弃签署 3007 用户和产品风险等级不匹配
      // if (datas[1].code == 3006) {
      //   this.assessShow = this.resetAssessShow == true ? false : true
      // }
    },
    showPopup() {
      this.show = true
    },
    onRevoke() {
      this.loading = true
      this.show = false
      cancelAuctionInvest(this.invest.id)
        .then((data) => {
          this.$toast({
            message: "撤销成功，认购资金预计1分钟内退回到余额",
            duration: "3000",
            onClose: () => {
              this.goableBack()
            }
          })
        })
        .catch((e) => {
          this.loading = false
          this.$toast(e.msg || e.message)
        })
    },
    goAssess() {
      this.$router.push({ name: "questions" })
    },
    getAuctionProductId(item) {
      if (item.version == 2) {
        let idsList = item.id.split(",")
        if (idsList.length > 2) {
          return `${idsList[0]}~${idsList[idsList.length - 1]}`
        } else {
          return idsList.join("、")
        }
      } else {
        return item.id
      }
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  margin: 0 13px;
  color: #666;

  // 拍品资产详情
  .auctionDetail {
    margin-top: 10px;
    margin-bottom: 100px;
    background-color: #fff;
    border-radius: 6px;

    .box {
      padding: 10px 16px 0 16px;
      .top-box {
        display: flex;
        justify-content: space-between;
        .look-protocol {
          margin-right: 15px;
          .look-sure {
            margin-right: 15px;
          }
        }
      }
      .title {
        font-size: 15px;
        font-weight: 700;
        padding-bottom: 10px;
      }
    }
    table {
      width: 100%;
      border-spacing: 0;
      border-collapse: collapse;
      table-layout: fixed;
      td,
      th {
        text-align: center;
        // line-height: 45px;
        border-color: #ebeaea;
        border-style: dashed;
        border-width: 1px 0 1px 0;
      }
      th {
        font-weight: 400;
        border-style: solid;
      }
      tr td {
        // width: calc((100% - 32px) / 4);
        word-wrap: break-word;
        word-break: break-all;
        padding: 5px 0;
      }
      tr:last-child td {
        border-bottom: none;
      }
    }
    a {
      color: blue;
    }
  }

  // 头部信息
  .main-box {
    margin-top: 55px;
    padding: 13px;
    border-radius: 6px;
    background-color: #fff;

    // 盒子1
    .header {
      border-bottom: 1px dashed #ebeaea;
      // border: 1px solid #000000;
      position: relative;
      // 标题
      .title {
        font-size: 16px;
        color: #333333;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .center {
        text-align: center;

        .t {
          margin-top: 15px;
          font-size: 30px;
          font-weight: 600;
          color: #fc6524;
        }
        .d {
          margin-top: 5px;
          margin-bottom: 20px;
          font-size: 15px;
        }
      }
      // 期限/收益率
      .down {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 15px;
        span {
          font-size: 14px;
          color: #999999;
        }
      }
      .down-left {
        text-align: center;
      }
      .down-right {
        text-align: center;
      }
      // 持有标签
      .van-tag {
        position: absolute;
        top: 50px;
        left: -14px;
      }
    }
    // 盒子2
    .income {
      //border-bottom: 1px dashed #ebeaea;
      .first {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 45px;
        .left {
          font-size: 14px;
          color: #666666;
        }
        .right {
          color: #333333;
        }
        .money {
          color: #fc6524;
        }
        .look-protocol {
          .look-sure {
            margin-right: 15px;
          }
          a {
            color: blue;
          }
        }
      }
      .b {
        padding-bottom: 15px;
      }
    }
    // 盒子3 plan
    .plan {
      .van-collapse-item {
        padding: 10px 0;

        .first {
          font-size: 13px;
          color: #666666;
          font-weight: 700;
          letter-spacing: 0.5px;
        }
        .table {
          width: 100%;
          margin-top: 16px;

          color: #666666;
          th,
          td {
            padding: 0;
            border: 1px solid #f1f1f1;
            text-align: center;
            vertical-align: middle;
            line-height: 1.1rem;
          }
          th {
            padding: 0 11px;
          }
        }
      }
      .van-cell {
        padding: 13px 0;
      }
      .van-hairline--top-bottom:after {
        border: none;
      }
      .van-cell--clickable::after {
        border: none;
      }
      /deep/ .van-cell__title {
        font-size: 13px;
        color: #666666;
        font-weight: 700;
      }
      /deep/ .van-cell__value {
        font-size: 13px;
        color: #333333;
      }
    }
  }
}

//撤销
.aginstshop {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  // border: 1px solid #000000;
  .text {
    font-size: 13px;
    letter-spacing: 1px;
    text-align: center;
    .ce {
      color: #fc6524;
    }
  }
  .van-button {
    height: 50px;
    font-size: 15px;
    letter-spacing: 1px;
  }
  .buy {
    background-color: rgb(234, 179, 96);
    color: #ffffff;
  }
  .sell-out {
    background-color: #d1d1d3;
    color: #ffffff;
  }
}

// 撤销认购 popup
.van-popup {
  border-radius: 5px;

  .popup-content {
    width: 275px;
    height: 160px;
    position: relative;

    .title {
      width: 210px;
      margin: auto;
      padding-top: 20px;
      font-size: 14px;
      color: #666;
    }

    .select {
      display: flex;
      height: 40px;
      position: absolute;
      bottom: 0;
      left: 0;

      span {
        line-height: 40px;
        text-align: center;
      }
      .sp1 {
        width: 137px;
        color: #666;
        background-color: #dcdcdc;

        height: 100%;
        border: none;
      }
      .sp2 {
        width: 138px;
        color: #fff;
        background-color: #fc6524;

        height: 100%;
        border: none;
      }
    }
  }
}

.assess-dialog {
  padding: 0.8rem;
  width: 70vw;

  .btn-assess {
    width: 70%;
    color: @golden;
    font-size: @font-size-xxl;
    border-color: @golden;
    border-radius: 5px;
  }
}
</style>
